import { makeStyles } from '@material-ui/core'
import theme from '../../../theme'

export const useProfileStyles = makeStyles({
  root: {
    width: '100%',
    maxHeight: '100vh',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '25px'
  },
  title: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '36px',
    lineHeight: '42px',
    color: '#333333',
    width: '100%',
    marginBottom: 23
  },
  description: {
    color: '#4F4F4F',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: '14px',
    width: '100%',
    marginBottom: 23
  },
  list: {
    width: '100%',
    maxWidth: '1024px',
    margin: '0 auto'
  }
})

export const useProfileCardStyles = makeStyles({
  root: {
    margin: theme.spacing(5),
    marginTop: 0
  },
  title: {
    color: '#4F4F4F',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: '14px',
    width: '100%',
    marginBottom: 23
  },
  description: {
    color: '#BDBDBD',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    textAlign: 'center',
    lineHeight: '14px',
    width: '100%',
    marginBottom: 23
  },
  cardContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  card: {
    display: 'flex',
    background: 'rgba(255, 255, 255, 1)',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    maxWidth: 340
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    flex: '1 0 auto',
    fontSize: 9,
    padding: '3px 8px',
    '&.MuiCardContent-root:last-child': {
      paddingBottom: 3
    }
  },
  cover: {
    width: 100,
    height: 100,
    margin: theme.spacing(1),
    borderRadius: '50%'
  },
  editModeActive: {
    top: theme.spacing(1) + 60
  }
})
